import Env from '../../base/env'
//import requestAnimFrame from '../vendor/raf'
//import cancelRequestAnimFrame from '../vendor/stopraf'
import Channels from '../../base/channels'

export default class Splashscreen
{
    constructor(view,_transform=false)
    {
        // DOM
        this.view = view
        this.$mask = this.view.querySelector('.jsMask')
        this.$bg = this.view.querySelector('.jsImage')
        if(Env.mobileCSS === true) {
            this.$bg = this.view.querySelector('.jsImageMobile')
        }
        // States
        this.getScrollTop = 0;
        this.offsetView = 1
        this.scaleMask = 0
        this.scaleBg = 0
        this.xBg = 0
        // Flags
        this.TRANSFORM_MODE = _transform;
        this.LOCKED = true
        // Fns
        this.setup()
    }

    actions()
    {
        this.checkTopPosition()
        this.hideMask()
    }

    checkTopPosition()
    {
        if(this.TRANSFORM_MODE == true)
        {
            var getValue = parseInt(this.view.closest('.layout').css('transform').split(',')[5]);
            if(isNaN(getValue) == false)
            {
                this.getScrollTop = getValue
            }
            else
            {
                this.getScrollTop = 0
            }
        }
        else
        {
            this.getScrollTop = Env.framework.toolbox.scrollPosition().scrollY
        }
    }

    hideMask()
    {
        const context = Env.framework.toolbox.getViewport().height * this.offsetView
        let ratio = this.getScrollTop / context

        if(ratio > 1) {
            ratio = 1
        }

        // Scale Fill
        this.scaleMask += (ratio - this.scaleMask) / 8
        TweenLite.set(this.$mask , { scaleX : this.scaleMask })

        // Scale BG
        const ratioBG = ratio * .12
        this.scaleBg += (ratioBG - this.scaleBg) / 8
        const newScaleBG = 1 + this.scaleBg
        const ratioXBG = ratio * 200
        this.xBg += (ratioXBG - this.xBg) / 8

        TweenLite.set(this.$bg , { scale : newScaleBG , x : this.xBg })

    }

    setup()
    {
        if(Env.tablet == true || Env.phone == true) return false;
    }

    unlocked()
    {
        this.LOCKED = false
    }

    onWatch()
    {
        if(this.LOCKED === false) {
            this.actions()
        }
    }
}